/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Weight_Unit_KgInputs */

const en_us2_profile_weight_unit_kg = /** @type {(inputs: Profile_Weight_Unit_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilograms (kg)`)
};

const pt_br2_profile_weight_unit_kg = /** @type {(inputs: Profile_Weight_Unit_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quilos (kg)`)
};

const es_419_profile_weight_unit_kg = /** @type {(inputs: Profile_Weight_Unit_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilogramos (kg)`)
};

const pt_pt2_profile_weight_unit_kg = /** @type {(inputs: Profile_Weight_Unit_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quilogramas (kg)`)
};

const fr_fr2_profile_weight_unit_kg = /** @type {(inputs: Profile_Weight_Unit_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilogrammes (kg)`)
};

const de_de2_profile_weight_unit_kg = /** @type {(inputs: Profile_Weight_Unit_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilogramm (kg)`)
};

const it_it2_profile_weight_unit_kg = /** @type {(inputs: Profile_Weight_Unit_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chilogrammi (kg)`)
};

/**
* | output |
* | --- |
* | "Kilograms (kg)" |
*
* @param {Profile_Weight_Unit_KgInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_weight_unit_kg = /** @type {((inputs?: Profile_Weight_Unit_KgInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Weight_Unit_KgInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_weight_unit_kg(inputs)
	if (locale === "es-419") return es_419_profile_weight_unit_kg(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_weight_unit_kg(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_weight_unit_kg(inputs)
	if (locale === "de-DE") return de_de2_profile_weight_unit_kg(inputs)
	if (locale === "it-IT") return it_it2_profile_weight_unit_kg(inputs)
	return en_us2_profile_weight_unit_kg(inputs)
});
export { profile_weight_unit_kg as "profile.weight_unit_kg" }